exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-news-news-tsx": () => import("./../../../src/templates/news/news.tsx" /* webpackChunkName: "component---src-templates-news-news-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---src-templates-projects-projects-tsx": () => import("./../../../src/templates/projects/projects.tsx" /* webpackChunkName: "component---src-templates-projects-projects-tsx" */)
}

